module.exports = __webpack_public_path__ + "img/hero-image-1.e73e66a1.jpg";